module.exports = __webpack_public_path__ + "static/Epic_Games_logo-ded792b96f5ae2e0d32e3bc6d940ef0a.svg";